import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=09b6cf1c&scoped=true"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=09b6cf1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b6cf1c",
  null
  
)

export default component.exports